
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFinanceInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"financeInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinanceInfoInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"businessInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessInfoInput"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingCycle"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingCycle"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasOutsourcedAccountant"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"outsourcedAccountant"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonInput"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreditApplicationUpdateTargets"}},"defaultValue":{"kind":"EnumValue","value":"UPDATE_FINANCE_INFO"},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creditApplicationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientTimeZone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCreditApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"financeInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"financeInfo"}}},{"kind":"Argument","name":{"kind":"Name","value":"businessInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"businessInfo"}}},{"kind":"Argument","name":{"kind":"Name","value":"billingCycle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingCycle"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasOutsourcedAccountant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasOutsourcedAccountant"}}},{"kind":"Argument","name":{"kind":"Name","value":"outsourcedAccountant"},"value":{"kind":"Variable","name":{"kind":"Name","value":"outsourcedAccountant"}}},{"kind":"Argument","name":{"kind":"Name","value":"creditApplicationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creditApplicationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientTimeZone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientTimeZone"}}},{"kind":"Argument","name":{"kind":"Name","value":"target"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target"}}},{"kind":"Argument","name":{"kind":"Name","value":"step"},"value":{"kind":"IntValue","value":"2"}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"creditApplicationFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validationErrors"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"error"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":802}};
    doc.loc.source = {"body":"#import '../creditApplicationFragment.gql'\n\nmutation UpdateFinanceInfo(\n  $financeInfo: FinanceInfoInput!\n  $businessInfo: BusinessInfoInput!\n  $billingCycle: BillingCycle\n  $hasOutsourcedAccountant: Boolean\n  $outsourcedAccountant: PersonInput\n  $target: CreditApplicationUpdateTargets = UPDATE_FINANCE_INFO\n  $creditApplicationId: ID!\n  $clientTimeZone: String\n) {\n  updateCreditApplication(\n    financeInfo: $financeInfo\n    businessInfo: $businessInfo\n    billingCycle: $billingCycle\n    hasOutsourcedAccountant: $hasOutsourcedAccountant\n    outsourcedAccountant: $outsourcedAccountant\n    creditApplicationId: $creditApplicationId\n    clientTimeZone: $clientTimeZone\n    target: $target\n    step: 2\n  ) {\n    ...creditApplicationFragment\n\n    validationErrors {\n      path\n      error\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../creditApplicationFragment.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UpdateFinanceInfo"] = oneQuery(doc, "UpdateFinanceInfo");
        
